/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './gluco-user.reducer';

export const GlucoUserDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const glucoUserEntity = useAppSelector(state => state.glucoUser.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="glucoUserDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.glucoUser.detail.title">GlucoUser</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.glucoUser.id">Id</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.glucoUser.active">Active</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="age">
              <Translate contentKey="tinyMedicRestApp.glucoUser.age">Age</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.age}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.glucoUser.country">Country</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.country}</dd>
          <dt>
            <span id="customRangeMax">
              <Translate contentKey="tinyMedicRestApp.glucoUser.customRangeMax">Custom Range Max</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.customRangeMax}</dd>
          <dt>
            <span id="customRangeMin">
              <Translate contentKey="tinyMedicRestApp.glucoUser.customRangeMin">Custom Range Min</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.customRangeMin}</dd>
          <dt>
            <span id="typeOfDiabeties">
              <Translate contentKey="tinyMedicRestApp.glucoUser.typeOfDiabeties">Type Of Diabeties</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.typeOfDiabeties}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.glucoUser.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.gender}</dd>
          <dt>
            <span id="height">
              <Translate contentKey="tinyMedicRestApp.glucoUser.height">Height</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.height}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.glucoUser.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.microSec}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.glucoUser.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.mobile}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.glucoUser.name">Name</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.name}</dd>
          <dt>
            <span id="tmPassword">
              <Translate contentKey="tinyMedicRestApp.glucoUser.tmPassword">Tm Password</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.tmPassword}</dd>
          <dt>
            <span id="preferredGlucoseUnit">
              <Translate contentKey="tinyMedicRestApp.glucoUser.preferredGlucoseUnit">Preferred Glucose Unit</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.preferredGlucoseUnit}</dd>
          <dt>
            <span id="preferredLanguage">
              <Translate contentKey="tinyMedicRestApp.glucoUser.preferredLanguage">Preferred Language</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.preferredLanguage}</dd>
          <dt>
            <span id="preferredRange">
              <Translate contentKey="tinyMedicRestApp.glucoUser.preferredRange">Preferred Range</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.preferredRange}</dd>
          <dt>
            <span id="preferredUnitA1c">
              <Translate contentKey="tinyMedicRestApp.glucoUser.preferredUnitA1c">Preferred Unit A 1 C</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.preferredUnitA1c}</dd>
          <dt>
            <span id="preferredUnitWeight">
              <Translate contentKey="tinyMedicRestApp.glucoUser.preferredUnitWeight">Preferred Unit Weight</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.preferredUnitWeight}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.glucoUser.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.timestampentry}</dd>
          <dt>
            <span id="parent">
              <Translate contentKey="tinyMedicRestApp.glucoUser.parent">Parent</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.parent ? 'true' : 'false'}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.glucoUser.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.dateOfBirth}</dd>
          <dt>
            <span id="uuid">
              <Translate contentKey="tinyMedicRestApp.glucoUser.uuid">Uuid</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.uuid}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.glucoUser.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.bloodGroup}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.glucoUser.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.glucoUser.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.cursor}</dd>
          <dt>
            <span id="imported">
              <Translate contentKey="tinyMedicRestApp.glucoUser.imported">Imported</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.imported ? 'true' : 'false'}</dd>
          <dt>
            <span id="deceased">
              <Translate contentKey="tinyMedicRestApp.glucoUser.deceased">Deceased</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.deceased ? 'true' : 'false'}</dd>
          <dt>
            <span id="deceasedDate">
              <Translate contentKey="tinyMedicRestApp.glucoUser.deceasedDate">Deceased Date</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.deceasedDate}</dd>
          <dt>
            <span id="deceasedReason">
              <Translate contentKey="tinyMedicRestApp.glucoUser.deceasedReason">Deceased Reason</Translate>
            </span>
          </dt>
          <dd>{glucoUserEntity.deceasedReason}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.glucoUser.contactDetails">Contact Details</Translate>
          </dt>
          <dd>{glucoUserEntity.contactDetails ? glucoUserEntity.contactDetails.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.glucoUser.tmUser">Tm User</Translate>
          </dt>
          <dd>{glucoUserEntity.tmUser ? glucoUserEntity.tmUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/gluco-user" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/gluco-user/${glucoUserEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GlucoUserDetail;
